import { orderStatusIds, transactionTypes } from "./paymentStatusFields"

export function getStatusDescHelper(status: any, transactiontype: any, firstAmount: string, lastAmount: string) {

    var firstamount = parseFloat(firstAmount);
    var lastamount = parseFloat(lastAmount);

    if (status === orderStatusIds.wait) {

        return {
            desc: "Ödeme Bekliyor",
            statusType: "primary"
        }
    }
    if (status == orderStatusIds.success) {
        if (transactiontype == transactionTypes.order) {
            return {
                desc: "Başarılı",
                statusType: "success"
            }

        } else if (transactiontype == transactionTypes.refund) {
            if (firstamount != lastamount && lastamount != 0) {
                return {
                    desc: "Kısmi İade",
                    statusType: "warning"
                }
            } else {
                return {
                    desc: "İade",
                    statusType: "warning"
                }
            }

        } else if (transactiontype == transactionTypes.cancel) {
            return {
                desc: "İptal",
                statusType: "warning"
            }
        }
    }
    if (status === orderStatusIds.error) {
        return {
            desc: "Başarısız",
            statusType: "error"
        }
    }

    return {
        desc: "",
        statusType: ""
    }
}